
import { useImpersonation as useImpersonationHook } from "./impersonation/useImpersonation";

export const useImpersonation = useImpersonationHook;
